import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useAsyncCancelState from 'global/asyncCancelState';
import { API_URL } from 'types/const';

/**
 * 라우터 정보가 변경될 때마다 비동기 취소
 */
function useAsyncCancel() {
  /* router */
  const { pathname } = useLocation();

  /* recoil */
  const { asyncCancel, resetAsyncCancel } = useAsyncCancelState();

  /* watch */
  useLayoutEffect(() => {
    // BU/공장 목록은 유지해야 되므로 예외 처리
    Object.entries(asyncCancel)
      .filter(
        ([url]) =>
          ![API_URL.common.bu, API_URL.common.plant.default].includes(url)
      )
      .forEach(([, cancel]) => {
        cancel();
      });

    resetAsyncCancel();
  }, [pathname]);
}

export default useAsyncCancel;
